// Utilities
import { mapState } from 'vuex';
import { getSentryEnv } from '@/sentry';
export default {
  name: 'CoreHelp',
  props: {
    manualPath: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      feedbackDialog: false,
      dialogTitle: ''
    };
  },
  computed: {
    ...mapState('app', ['color', 'UiTheme']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    showSystemStatus() {
      switch (getSentryEnv()) {
        case 'production-saas':
          return true;
        case 'staging':
          return true;
        case 'development':
          return true;
        case 'local':
          return true;
        default:
          return false;
      }
    }
  },
  methods: {}
};